import { CSSProperties } from '@bcp-nextgen-dx-component-factory/design-system';

import { BreakpointsRender, CUSTOM_LAPTOP_WIDTH } from '../breakpointsRender';
import { FooterDesktop } from './footer.desktop';
import { FooterMobile } from './footer.mobile';

export interface FooterProps {
	styles?: CSSProperties;
}

export const Footer = (props: FooterProps) => (
	<footer>
		<BreakpointsRender
			mobile={<FooterMobile {...props} />}
			laptop={<FooterDesktop {...props} />}
			customLaptopWidth={CUSTOM_LAPTOP_WIDTH}
		/>
	</footer>
);
